import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSettingsContext } from '@/contexts/SettingsContext';

interface InternalRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Route-level authorization wrapper for internal-only features (Hollywood Trucks staff)
 *
 * Only checks is_internal flag - no admin role required.
 * Used for Records section which all internal staff can access.
 *
 * Usage:
 *   <Route path="/records" element={
 *     <InternalRoute>
 *       <RecordsLayout />
 *     </InternalRoute>
 *   } />
 */
export function InternalRoute({ children, redirectTo = '/map' }: InternalRouteProps) {
  const { user, loading } = useSettingsContext();

  // Show nothing while loading (prevents flash of unauthorized content)
  if (loading) {
    return null;
  }

  // Redirect if user is not internal staff
  if (!user?.is_internal) {
    return <Navigate to={redirectTo} replace />;
  }

  // Authorized - render children
  return <>{children}</>;
}
